import { CreditCardCodes } from '../constants';

/**
 * Maps VGS Collect cardType to CreditCardCodes
 * VGS cardType values: "mastercard", "discover", "visa", "jcb", "unionpay", "amex"
 * Returns the corresponding CreditCardCodes value (e.g., 'MC', 'DS', 'VI', 'JC', 'CU', 'AX')
 *
 * @param {string} vgsCardType - The card type from VGS Collect (lowercase)
 * @returns {string} The corresponding CreditCardCodes value, or empty string if not found
 */
const getCardCodeFromVGSCardType = (vgsCardType) => {
  if (!vgsCardType) {
    return CreditCardCodes.Empty || '';
  }

  const cardTypeLower = vgsCardType.toLowerCase().trim();

  // Map VGS cardType values to CreditCardCodes
  const vgsToCardCodeMap = {
    visa: CreditCardCodes.Visa,
    mastercard: CreditCardCodes.MasterCard,
    amex: CreditCardCodes.Amex,
    discover: CreditCardCodes.Discover,
    jcb: CreditCardCodes.JCB,
    unionpay: CreditCardCodes.UnionPay,
    dinersclub: CreditCardCodes.DinersClub,
  };

  return vgsToCardCodeMap[cardTypeLower] || CreditCardCodes.Empty || '';
};

export default getCardCodeFromVGSCardType;
